module.exports = __webpack_public_path__ + "static/img/logo.9728519.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/logo.png
// module id = AtYS
// module chunks = 1